export const Products = ["GDPR", "KVKK", "DDO", "BGYS", "RISK"];
export const ScopedProducts = [...Products, "PLATFORM"];
